import React from 'react'
import { Text } from 'native-base'
import type { StyleProp, TextStyle } from 'react-native'

const ButtonText: React.FC<{
  style?: StyleProp<TextStyle>;
  testID?: string;
  smallFontSize?: boolean;
}> = ({ children, style, testID, smallFontSize }) => {
  return (
    <Text
      testID={testID}
      fontSize={smallFontSize ? 'sm' : 'md'}
      fontWeight={700}
      fontFamily="Lato"
      color="dark"
      style={style}
    >
      {children}
    </Text>
  )
}

export default ButtonText
